 jQuery(document).ready(function($) {

     // Section FAQs Tab
     if ($('.faqs__section--tabs .faqs__tabs--item').length > 0) {
         $(".faqs__section--tabs .faqs__box--items-faqs").addClass('active');
         $('.faqs__section--tabs .faqs__tabs--all-item').click(function() {
             $(".faqs__section--tabs .faqs__box--items-faqs .itemsfaqs--answer").slideUp();
             $(".faqs__section--tabs .faqs__box--items-faqs").addClass('active');
         });
     }
     $('.faqs__section--tabs .faqs__tabs--item').click(function() {
         var name = $(this).attr('data-tab-name');
         var title = $(this).find('h6').text();
         $('.faqs__tabs--button h6').text(title);
         $('.faqs__tabs--dropdown-content .faqs__tabs--swipper--title h6').removeClass('active');
         $('.faqs__tabs--dropdown-content .faqs__tabs--swipper--title').eq($(this).index()).find('h6').addClass('active');
         $('.faqs__tabs--item').removeClass('swiper-slide-active');
         $(this).addClass('swiper-slide-active');
         if (name != 'all') {
             $(".faqs__section--tabs .faqs__box--items-faqs .itemsfaqs--answer").slideUp();
             $(".faqs__section--tabs .faqs__box--items-faqs").removeClass('active');
             $('.' + name).addClass('active');
         } else {
             $(".faqs__section--tabs .faqs__box--items-faqs").addClass('active');
         }
     });
     $(".faqs__section--tabs .itemsfaqs--title-question").click(function() {
         $(this).parents(".faqs__section--tabs .faqs__box--items-faqs").toggleClass('show__content').find(".itemsfaqs--answer").slideToggle();
         $(this).parents(".faqs__section--tabs .faqs__box--items-faqs").prevAll(".faqs__box--items-faqs").removeClass('show__content').find(".itemsfaqs--answer").slideUp();
         $(this).parents(".faqs__section--tabs .faqs__box--items-faqs").nextAll(".faqs__box--items-faqs").removeClass('show__content').find(".itemsfaqs--answer").slideUp();
     });

     var swiperFaqsTab = new Swiper(".faqs__section--tabs .faqs__tabs--swipper", {
         slidesPerView: 'auto',
         navigation: {
             nextEl: '.faqs__section--tabs .swiper-button-next',
             prevEl: '.faqs__section--tabs .swiper-button-prev',
         },
         on: {
             slideChange: function() {
                 var name = $('.faqs__section--tabs .faqs__tabs--item').eq(this.activeIndex).attr('data-tab-name');
                 var title = $('.faqs__section--tabs .faqs__tabs--item').eq(this.activeIndex).find('h6').text();
                 $('.faqs__tabs--button h6').text(title);
                 $('.faqs__tabs--dropdown-content .faqs__tabs--swipper--title h6').removeClass('active');
                 $('.faqs__tabs--dropdown-content .faqs__tabs--swipper--title').eq(this.activeIndex).find('h6').addClass('active');
                 $('.faqs__tabs--item').removeClass('swiper-slide-active');
                 $(this).addClass('swiper-slide-active');
                 if (name != 'all') {
                     $(".faqs__section--tabs .faqs__box--items-faqs .itemsfaqs--answer").slideUp();
                     $(".faqs__section--tabs .faqs__box--items-faqs").removeClass('active');
                     $('.' + name).addClass('active');
                 } else {
                     $(".faqs__section--tabs .faqs__box--items-faqs").addClass('active');
                 }
             },
         },
         breakpoints: {

             0: {
                 slidesPerView: 1,
                 spaceBetween: 20,
             },

             767: {
                 slidesPerView: 2,
                 spaceBetween: 50,
             },

             1170: {
                 slidesPerView: 'auto',
                 spaceBetween: 50
             },

             1366: {
                 slidesPerView: 'auto',
                 spaceBetween: 40
             },

             1600: {
                 slidesPerView: 'auto',
                 spaceBetween: 40
             },

             1700: {
                 slidesPerView: 5,
                 spaceBetween: 40
             },
         },
     });

     $('.faqs__tabs--button').click(function() {
         $('.faqs__tabs--dropdown-content').slideToggle();
     });

     $('.faqs__tabs--dropdown-content .faqs__tabs--swipper--title').click(function() {
         var title = $(this).find('h6').text();
         $('.faqs__tabs--dropdown-content .faqs__tabs--swipper--title h6').removeClass('active');
         $(this).find('h6').addClass('active');
         $('.faqs__tabs--dropdown-content').slideUp();
         $('.faqs__tabs--button h6').text(title);
     });


     $('.itemsconditions__item--box').click(function() {
         var indexPOPUP = $(this).attr('data-conditions-popup');
         $('body').addClass('modal__showed');
         $(this).find('.conditions__section--box .itemsconditions__modal-popup').removeClass('active');
         $(this).parents('.conditions__section--box').find('.itemsconditions__popup--index-' + indexPOPUP).addClass('active');
     });
     $('.modal__popup--button-close').click(function() {
         $(this).parents('.conditions__section--box .itemsconditions__modal-popup').removeClass('active');
         $('body').removeClass('modal__showed');
     });
     $(document).mouseup(function(e) {
         var container = $('.itemsconditions--box-popup');
         if (!container.is(e.target) && container.has(e.target).length === 0) {
             $('.itemsconditions__modal-popup').removeClass('active');
             $('body').removeClass('modal__showed');
         }
     });

     var swiperConditions = new Swiper(".swiperConditions--Main", {
         slidesPerView: 4,
         spaceBetween: 30,
         navigation: {
             nextEl: ".swiperConditions--Main .swiper-button-next",
             prevEl: ".swiperConditions--Main .swiper-button-prev",
         },
         scrollbar: {
             el: ".conditions__section--container .swiper-scrollbar",
         },
         breakpoints: {
             0: {
                 slidesPerView: 1,
                 spaceBetween: 10
             },
             600: {
                 slidesPerView: 2,
                 spaceBetween: 20
             },
             900: {
                 slidesPerView: 3,
                 spaceBetween: 25
             },
             1600: {
                 slidesPerView: 4,
                 spaceBetween: 30
             }
         }
     });



     var swiper = new Swiper(".general-slider-container", {
         slidesPerView: 3,
         spaceBetween: 35,
         pagination: {
             el: ".swiper-pagination",
             type: "progressbar",
         },
         scrollbar: {
             el: ".swiper-scrollbar",
         },

         navigation: {
             nextEl: ".swiper-button-next",
             prevEl: ".swiper-button-prev",
         },
         breakpoints: {
             0: {
                 slidesPerView: 1,
                 spaceBetween: 10
             },
             600: {
                 slidesPerView: 2,
                 spaceBetween: 20
             },
             900: {
                 slidesPerView: 3,
                 spaceBetween: 25
             },
             1280: {
                 slidesPerView: 3,
                 spaceBetween: 35
             }
         }
     });

     // FAQs tabs

     function initSwiper() {
         return new Swiper(".company-overview-list", {
             slidesPerView: 4,
             spaceBetween: 30,
             navigation: {
                 nextEl: ".swiper-button-next",
                 prevEl: ".swiper-button-prev",
             },
             scrollbar: {
                 el: ".swiper-scrollbar",
             },
             pagination: {
                 el: ".swiper-pagination",
                 clickable: true
             },
             breakpoints: {
                 0: {
                     slidesPerView: 1,
                     spaceBetween: 10
                 },
                 600: {
                     slidesPerView: 2,
                     spaceBetween: 20
                 },
                 900: {
                     slidesPerView: 3,
                     spaceBetween: 25
                 },
                 1280: {
                     slidesPerView: 4,
                     spaceBetween: 30
                 }
             }
         });
     }

     var swiperFaqsTab = initSwiper();

     function destroySwiper() {
         if (swiperFaqsTab && swiperFaqsTab.destroy) {
             swiperFaqsTab.destroy(true, true);
         }


         // Function to check window width and reinitialize Swiper if needed
         function checkWindowWidth() {
             if (window.innerWidth > 768) {
                 if (!swiperFaqsTab || swiperFaqsTab.destroyed) {
                     swiperFaqsTab = initSwiper();
                 }
             } else {
                 destroySwiper();
             }
         }

         // Check window width on initial load
         checkWindowWidth();

         // Check window width on window resize
         window.addEventListener('resize', checkWindowWidth);
     }

     const toggleItem = () => {
         if ($(".item_requirements .circumstance").hasClass('mobile')) {
             $(".item_requirements .mobile").off('click').click(function() {
                 $(this).toggleClass('show__content').next().slideToggle();
                 $(this).parents().prevAll().removeClass('show__content').find('.box-mobile').slideUp();
                 $(this).parents().nextAll().removeClass('show__content').find('.box-mobile').slideUp();
             });
         } else {
             $(this).toggleClass('show__content').next().stop();
             $(this).parents().prevAll().removeClass('show__content').find('.box-mobile').stop();
             $(this).parents().nextAll().removeClass('show__content').find('.box-mobile').stop();
         }
     };

     $(window).resize(function() {
         if ($(window).width() < 768) {

             $(".item_requirements .circumstance").addClass('mobile');
             $(".item_requirements .box-mobile").css('display', 'none');
             toggleItem();
             // Open the first item
             const firstItem = $(".item_requirements .circumstance").first();
             if (firstItem.length > 0) {
                 firstItem.addClass('show__content').next().slideDown();
             }
         } else {
             $(".item_requirements .circumstance").removeClass('mobile').off('click'); // Remove click event handler
             $(".item_requirements .circumstance").removeClass('show__content').next().css('display', '');
             $(".item_requirements .box-mobile").css('display', 'flex');
         }
     });

     // Initial setup
     if ($(window).width() < 768) {
         $(".item_requirements .circumstance").addClass('mobile');
         $(".item_requirements .box-mobile").css('display', 'none');
         toggleItem();
         // Open the first item
         const firstItem = $(".item_requirements .circumstance").first();
         if (firstItem.length > 0) {
             firstItem.addClass('show__content').next().slideDown();
         }
     } else {
         $(".item_requirements .circumstance").removeClass('mobile').off('click'); // Remove click event handler
         $(".item_requirements .circumstance").removeClass('show__content').next().css('display', '');
         $(".item_requirements .box-mobile").css('display', 'flex');
     }




     $('.general-slider-items').click(function() {
         var indexPOPUP = $(this).attr('data-conditions-popup');
         $('body').addClass('modal__showed');
         $(this).find('.about-us.general-slider .itemsconditions__modal-popup').removeClass('active');
         $(this).parents('.about-us.general-slider').find('.itemsconditions__popup--index-' + indexPOPUP).addClass('active');
     });
     $('.modal__popup--button-close').click(function() {
         $(this).parents('.about-us.general-slider .itemsconditions__modal-popup').removeClass('active');
         $('body').removeClass('modal__showed');
     });
     $(document).mouseup(function(e) {
         var container = $('.itemsconditions--box-popup');
         if (!container.is(e.target) && container.has(e.target).length === 0) {
             $('.itemsconditions__modal-popup').removeClass('active');
             $('body').removeClass('modal__showed');
         }
     });

     /** 
      * Set slider for work step
      * Using Swiper
      */
     var workStepList = new Swiper(".work-step-list--inner", {
         slidesPerView: 3,
         spaceBetween: 62,
         navigation: {
             nextEl: ".swiper-button-next",
             prevEl: ".swiper-button-prev",
         },
         scrollbar: {
             el: ".swiper-scrollbar",
         },
         breakpoints: {
             0: {
                 slidesPerView: 1,
                 spaceBetween: 10
             },
             600: {
                 slidesPerView: 2,
                 spaceBetween: 30
             },
             900: {
                 slidesPerView: 3,
                 spaceBetween: 35
             },
             1280: {
                 spaceBetween: 62
             }
         },
     });

     /** 
      * Set slider for lives-improved
      * Using Swiper
      */
     var livesImprovedList = new Swiper(".lives-improved-list", {
         slidesPerView: 1,
         navigation: {
             nextEl: ".swiper-button-next",
             prevEl: ".swiper-button-prev",
         },
     });

     /** 
      * Set slider for left slider
      * Using Swiper
      */
     var leftSlider = new Swiper(".section-left-slider__images-list", {
         slidesPerView: 2,
         spaceBetween: 38,
         navigation: {
             nextEl: ".swiper-button-next",
             prevEl: ".swiper-button-prev",
         },
         breakpoints: {
             0: {
                 slidesPerView: 1,
                 spaceBetween: 10
             },
             600: {
                 slidesPerView: 2,
                 spaceBetween: 30
             },
             900: {
                 slidesPerView: 2,
                 spaceBetween: 35
             }
         },
         scrollbar: {
             el: ".swiper-scrollbar",
         },
     });


     /**
      * Auto play video in Clinical Support page
      * Section How to
      */

     // Get all video elements with the class 'video_step'
     var videoStep = document.getElementsByClassName('video_step');

     // Set control to false for all video elements
     for (var i = 0; i < videoStep.length; i++) {
         videoStep[i].controls = false;

         // Add click event listener to each video element
         videoStep[i].addEventListener('click', function() {
             // Toggle play and pause when clicked
             if (this.paused) {
                 this.play();
             } else {
                 this.pause();
             }
         });
     }

     /**
      * Set top button-prev and button-next in work step
      */
     const setTopButton = () => {
         // height video
         var heightVideo = $('.video_step').height();

         //  alert('setTopButton');

         //  ratio
         var ratio = 2;

         //  value of top button
         var topButton = heightVideo / ratio;

         //  set css Top to button
         $('.clinical-support-page .container-work-step .swiper-button').css('top', topButton + 'px')
     }

     setTopButton();

     setTimeout(() => {
         setTopButton();
     }, 500);

     $(window).resize(function() {
         setTopButton();
     });

     if ($(".clinical-support-page").length) {

         $(".clinical-support-page .video-section").attr('play', false);

         $(window).scroll(function() {

             var heightVideo = $(".clinical-support-page .video-section").height();

             var play = $(".clinical-support-page .video-section").attr('play');

             if (($(window).scrollTop() + heightVideo) > $(".clinical-support-page .video-section").offset().top) {

                 if (play == "false") {
                     $(".clinical-support-page .video-section .video-section__poster").click();
                     $(".clinical-support-page .video-section").attr('play', true);
                     return
                 }
             }

         });
     }
 });